<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer007" role="doc-foreword">
<p class="pl-center">And above all these things put on charity, which is the bond of perfectness. And let the peace of God rule in your hearts, to the which also ye are called in one body; and be ye thankful.</p>
<p class="pl-citation">—<em class="italic">Colossians</em> <span class="roman">3:14–15</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bible_Verse.vue?3c3780e3